module.exports = __webpack_public_path__ + "static/pool-3a504e70dcc177ae7ff1b81331aedfa4.jpg";